import _defineProperty from "/var/lib/jenkins/workspace/mr-learner-frontend-production/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var genStepsCustomIconStyle = function genStepsCustomIconStyle(token) {
  var _ref;

  var componentCls = token.componentCls,
      customIconTop = token.customIconTop,
      customIconSize = token.customIconSize,
      customIconFontSize = token.customIconFontSize;
  return _ref = {}, _defineProperty(_ref, "".concat(componentCls, "-item-custom"), _defineProperty({}, "> ".concat(componentCls, "-item-container > ").concat(componentCls, "-item-icon"), _defineProperty({
    height: 'auto',
    background: 'none',
    border: 0
  }, "> ".concat(componentCls, "-icon"), {
    top: customIconTop,
    width: customIconSize,
    height: customIconSize,
    fontSize: customIconFontSize,
    lineHeight: "".concat(customIconFontSize, "px")
  }))), _defineProperty(_ref, "&:not(".concat(componentCls, "-vertical)"), _defineProperty({}, "".concat(componentCls, "-item-custom"), _defineProperty({}, "".concat(componentCls, "-item-icon"), {
    width: 'auto',
    background: 'none'
  }))), _ref;
};

export default genStepsCustomIconStyle;